__webpack_require__.p = "/jo/ar/customer-service/returns-claims/spareparts/";